import { InfoBlock } from 'app/components/commons/InfoBlock/InfoBlock';
import type { CustomerDataResponse } from 'app/typings/core/admin/bookings/booking';

type Props = {
  customer: CustomerDataResponse;
};

export const Guest = ({ customer }: Props) => (
  <InfoBlock
    title="Guest"
    rows={[
      { label: 'First name', value: customer.firstName },
      { label: 'Last name', value: customer.lastName },
    ]}
  />
);
